<template>
  <section>
    <GroupCheckboxesWithValidation
      v-model="checkedObjetsLabels"
      :label="$t('instruction.objet-realisation')"
      :data="allObjetsRealisationLabels()"
      :vertical-display="true"
      :input-label="$t('instruction.AUTRE')"
      :ext-input-value="internalProjetAnnuel.objectConcretRealisationAutre"
      vid="objet"
      :disabled="readOnly"
      @manual-change="changeObjetsRealisation"
      @input-change="changeObjetRealisationAutre"
    />
  </section>
</template>

<script lang="ts">
import { defineComponent } from "vue"
import { PropType } from "vue"
import { ProjetAnnuelDTO } from "@/model/bean/GeneratedDTOs"
import GroupCheckboxesWithValidation from "@/views/inputs/GroupCheckBoxesWithValidation.vue"
import { EnumHelper } from "@/model/bean/EnumHelper"

export default defineComponent({
  name: "InstructionObjetsRealisation",
  components: {
    GroupCheckboxesWithValidation,
  },
  props: {
    projetAnnuel: {
      type: Object as PropType<ProjetAnnuelDTO>,
      required: true,
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
  },

  emits: ["projet-annuel-updated"],
  data() {
    return {
      internalProjetAnnuel: new ProjetAnnuelDTO(),
      allObjetsRealisation: EnumHelper.allObjetsRealisation,
      checkedObjetsLabels: [] as string[],
    }
  },
  watch: {
    projetAnnuel(): void {
      this.refreshInternalProjectAnnuel()
    },
  },
  created(): void {
    this.refreshInternalProjectAnnuel()
  },
  methods: {
    refreshInternalProjectAnnuel(): void {
      this.internalProjetAnnuel = { ...this.projetAnnuel }
      this.refreshChecked()
    },

    refreshChecked(): void {
      if (this.internalProjetAnnuel.objectsConcretRealisation) {
        this.checkedObjetsLabels = this.internalProjetAnnuel.objectsConcretRealisation.map(
          (objet) => {
            return this.$t("instruction." + objet).toString()
          },
        )
      }
      if (this.internalProjetAnnuel.objectConcretRealisationAutre) {
        this.checkedObjetsLabels.push(this.$t("instruction.AUTRE").toString())
      }
    },

    allObjetsRealisationLabels(): string[] {
      return this.allObjetsRealisation.map((objet) => {
        return this.$t("instruction." + objet).toString()
      })
    },

    changeObjetsRealisation(): void {
      const updatedProjet = { ...this.internalProjetAnnuel }
      updatedProjet.objectsConcretRealisation = this.allObjetsRealisation.filter((objet) => {
        return this.checkedObjetsLabels.indexOf(this.$t("instruction." + objet).toString()) > -1
      })
      if (this.checkedObjetsLabels.indexOf(this.$t("instruction.AUTRE").toString()) == -1) {
        updatedProjet.objectConcretRealisationAutre = ""
      }
      this.$emit("projet-annuel-updated", updatedProjet)
    },

    changeObjetRealisationAutre(newValue: string): void {
      const updatedProjet = { ...this.internalProjetAnnuel }
      
      const indexAutre = this.checkedObjetsLabels.indexOf(this.$t("instruction.AUTRE").toString())
      
      // Only update value if AUTRE checkbox is checked
      if (indexAutre !== -1) {
        updatedProjet.objectConcretRealisationAutre = newValue
      } else {
        updatedProjet.objectConcretRealisationAutre = ""
      }
      
      this.$emit("projet-annuel-updated", updatedProjet)
    },
  },
})
</script>
